import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationService } from '.././validation.service';
import { SnackbarService } from '.././snackbar.service';
import { HttpService } from '.././http.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '.././time.service';
import { filter } from 'rxjs/operators';
import { StorageService } from '../storage.service';
import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';


export interface spotData {
  name: string;
  mobile: string;
  vehicle_number: string;
  vehicle_type: string;
  gps_id?: string;
  gps_provider?: string;
  has_smart_phone: boolean;
  password?: string;
  driver_licence_no: string;
  driver_licence_expiry_date: string;
  selectedCarrier?: string;
  dedicated_to?: string;
  carrier_type?: string;
  capacity?: string;
  materials: string[];
  registered_for?:string[];
  preferred_zone?: string;
  preferred_location?: string;
  driver_image?: string;
  comments?: string;
  rc_laden?: number;
  vehicle_weight?: number;
  desired_weight?: number;
  engine_number?: string;
  chassis_number?: string;
  load?: string;
  allocation_id?: string;
}
export interface spotCapacityData {
  capacity?: number;
  vehicle_qty?: number;
  rc_Laden_weight?: number;
  desired_weight?: number,
}

@Component({
  selector: 'app-assign-load',
  templateUrl: './assign-load.component.html',
  styleUrls: ['./assign-load.component.scss']
})
export class AssignLoadComponent implements OnInit {
  spotVehicleData: spotData = {
    name: '',
    mobile: '',
    vehicle_number: '',
    vehicle_type: '',
    has_smart_phone: false,
    driver_licence_no: '',
    driver_licence_expiry_date: '',
    password: '',
    selectedCarrier: '',
    dedicated_to: '',
    preferred_zone: '',
    preferred_location: '',
    materials: [],
    registered_for:[],
    chassis_number: '',
    engine_number: '',
  };
  carrierTypes: any = ['CT', 'PT'];
  carrier_type: any = '';
  capacityData: spotCapacityData = {
    capacity: 0,
    vehicle_qty: 0,
    rc_Laden_weight: 0,
    desired_weight: 0,
  };
  preferred = {
    zone: '',
    location: '',
    load: '',
  };
  selectedVehicle = '';
  confirmPassword;
  showVerifyLinks;
  expiryDate;
  spinner = false;
  checked = false;
  selectedVehicleType: any = {};
  showLoader = false;
  vehicleType: any = {};
  vehicles: any = [];
  vehicle_pattern;
  defaultVehicle: any;
  registerForArr: any = [];
  dedicatedShippersArr: any = [];
  searchVehicleNo = '';
  searchLinNo = '';
  assets;
  assetsArray;
  selectedGPSProvider;
  selectedAsset;
  showGPSProvider = false;
  gps_providers = [];
  ksaGpsProviders = [];
  inGpsProviders = [];
  gpsProviders: any = [];
  type;
  carrierList: any;
  vehicleTypes: any;
  vehicleType1: any;
  country: string;
  states: any = [];
  stream: MediaStream;
  driverImage: any;
  assignArr = [];
  vehicle_number = '';
  comments = '';
  materialsArr: any[];
  selectedRegisterForName: any;
  dedicatedName: any;
  shipperName: any;
  customer_name = '';
  // registered_for: any = [];
  material = [];
  selectedMaterial = [];
  allVehicles: any = [];
  materialList: any = [{ name: '', load: 0 }];
  parital_vehicle_number = '';
  language = [
    { name: "Bengali", value: "bengali" },
    { name: "Gujarati", value: "gujarati" },
    { name: "Hindi", value: "hindi" },
    { name: "Kannada", value: "kannade" },
    { name: "Oriya", value: "oriya" },
    { name: "Tamil", value: "tamil" },
    { name: "Telugu", value: "telugu" }
  ];
  vehicleRegNumbers = [];
  selectedVehicleNo = [];
  selectedLinNumber = [];
  selected = '';
  lin: any;
  lin_number: any;
  selectedLin = '';
  linCarrierDetails: any;
  liin: any;
  load_id: any;

  insurance: any = {
    no: '',
    expiry: '',
  };
  enbleMaterial = true;
  enbleregisterfor=true;
  // isDeleteDriver = false;
  messageDeleteStatus = '';
  selectedCarrier: any;
  carrierId: Subscription;
  details = [];
  vehicleNo: any = '';
  mobileNo: any = '';
  driverDetails: any;
  constructor(
    private dialog: MatDialogRef<AssignLoadComponent>,
    private valid: ValidationService,
    private snackbar: SnackbarService,
    private timeService: TimeService,
    private http: HttpService,
    private translate: TranslateService,
    private storage: StorageService,
    private events: EventService,
    @Inject(MAT_DIALOG_DATA) private parentData: any,
    private matDialog: MatDialog
  ) {
    dialog.disableClose = true;
  }

  ngOnInit() {
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.selectedCarrier = data.carrier_id;
      }
    );
    this.selectedCarrier = this.storage.getFromCookie('carrier_id');
    this.showVerifyLinks = environment.country === 'IN';
    this.parentData && this.parentData.type ? this.parentData.type : '';
    this.vehicle_pattern = environment.vehicle_pattern;
    this.getVehicleTypes()
    this.getGPSProviders();
    // this.getShippers();
    this.getDedicatedShippers();
    this.states = JSON.parse(localStorage.getItem('states'));
    this.getCarriers();
    this.getZones();
    this.getVehiclesDetails();
    // this.selectCarrierList();
   
    this.vehicleTypes = this.parentData;
    this.type =

    this.getLinNumbers();
  }

  getGPSProviders() {
    const payload = {
      name: 'gps_providers',
    };
    this.http.get('constants/get_gps_providers', payload).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          const data = response.data;
          this.gps_providers = data[0].value;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  getMaterials() {
    this.showLoader = true;
    this.http.get('v1/constants/materials', { shipper: this.spotVehicleData.dedicated_to }).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.materialsArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.materialsArr.push(temp);
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  validate(data) {
    console.log(this.spotVehicleData);
    const loadUpperCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 1.05;
    const loadLowerCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 0.95;
    const desiredWeightUpperCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 1.1;
    const desiredWeightLowerCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 0.9;

    this.spotVehicleData.password = this.spotVehicleData.mobile;
    if (
      !this.valid.isEmpty(this.spotVehicleData.name) &&
      !this.valid.isEmpty(this.spotVehicleData.mobile) &&
      !this.valid.isEmpty(this.spotVehicleData.vehicle_number) &&
      !this.valid.isEmpty(this.spotVehicleData.password) &&
      !this.valid.isEmpty(this.spotVehicleData.vehicle_type) &&
      !this.valid.isEmpty(this.spotVehicleData.driver_licence_no) &&
      !this.valid.isEmpty(this.spotVehicleData.driver_licence_expiry_date)
    ) {
      if (
        environment.country == 'IN' &&
        !this.valid.isVehicle(this.spotVehicleData.vehicle_number)
      ) {
        this.snackbar.openSnackBar(
          this.translate.instant('Enter valid vehicle number'),
          '',
          'err'
        );
        return false;
      } else if (
        (environment.country == 'SA' || environment.country == 'BR') &&
        !this.valid.isKsaVehicle(this.spotVehicleData.vehicle_number)
      ) {
        this.snackbar.openSnackBar(
          this.translate.instant('Enter valid vehicle number'),
          '',
          'err'
        );
        return false;
      } else if (!this.valid.isMobile(this.spotVehicleData.mobile)) {
        this.snackbar.openSnackBar(
          this.translate.instant('Enter valid mobile number'),
          '',
          'err'
        );
        return false;
      } else if (this.spotVehicleData.vehicle_weight > 90) {
        this.snackbar.openSnackBar(
          this.translate.instant('Vehicle RC Gross Passing Weight cannot be greater than 90 MT'),
          '',
          'err'
        );
        return false;
      } else if (this.spotVehicleData.rc_laden > (this.spotVehicleData.vehicle_weight * 95 / 100)) {
        this.snackbar.openSnackBar(
          this.translate.instant(`Vehicle RC Laden Weight cannot be greater than ${(this.spotVehicleData.vehicle_weight * 95 / 100)} MT`),
          '',
          'err'
        );
        return false;
      } else if (parseInt(this.spotVehicleData.capacity) > loadUpperCap) {
        this.snackbar.openSnackBar(
          this.translate.instant(`Load cannot be greater than ${loadUpperCap} MT`),
          '',
          'err'
        );
        return false;
      } else if (parseInt(this.spotVehicleData.capacity) < loadLowerCap) {
        this.snackbar.openSnackBar(
          this.translate.instant(`Load cannot be less than ${loadLowerCap} MT`),
          '',
          'err'
        );
        return false;
      } else if (this.spotVehicleData.desired_weight > desiredWeightUpperCap) {
        this.snackbar.openSnackBar(
          this.translate.instant(`Desired Weight cannot be greater than ${desiredWeightUpperCap} MT`),
          '',
          'err'
        );
        return false;
      } else if (this.spotVehicleData.desired_weight < desiredWeightLowerCap) {
        this.snackbar.openSnackBar(
          this.translate.instant(`Desired Weight cannot be less than ${desiredWeightLowerCap} MT`),
          '',
          'err'
        )
        return false;
      }

    } else {
      this.snackbar.openSnackBar(
        this.translate.instant('Please enter all the mandatory fields'),
        '',
        'err'
      );
      return false;
    }
    return true;
  }

  selectVehicleType(event) {
    if (!event.checked) {
      this.vehicleType.id = this.selectedVehicleType.id;
      this.vehicleType.name = this.selectedVehicleType.name;
    } else {
      this.vehicleType.id = '';
      this.vehicleType.name = '';
    }
  }

  setExpiryDate(date, change = '', type) {
    if (!change) {
      const temp: any = this.timeService.IsoToUTC(date);
      if (type == 'licence_expiry') {
        this.spotVehicleData.driver_licence_expiry_date = temp.ts;
      } else {
        this.insurance.expiry = temp.ts;
      }
    } else {

      if (type == 'licence_expiry') {
        this.spotVehicleData.driver_licence_expiry_date = this.timeService.toUTCEpoch(date);
      } else {
        this.insurance.expiry = this.timeService.toUTCEpoch(date);
      }

    }
  }

  assignLoad() {
    console.log(this.spotVehicleData);
    this.spotVehicleData.chassis_number = this.driverDetails.chassis_number;
    this.spotVehicleData.driver_licence_expiry_date = this.driverDetails.licence.expiry_date;
    this.spotVehicleData.driver_licence_no = this.driverDetails.licence.no;
    this.spotVehicleData.engine_number = this.driverDetails.engine_number;
    this.spotVehicleData.mobile = this.driverDetails.mobile;
    this.spotVehicleData.name = this.driverDetails.name;
    this.spotVehicleData.password = this.driverDetails.mobile;
    this.spotVehicleData.preferred_location = this.parentData.customer[0].city;
    this.spotVehicleData.preferred_zone = this.parentData.customer[0].locality;
    this.spotVehicleData.selectedCarrier = this.driverDetails.carrier_unit._id;
    this.spotVehicleData.vehicle_number = this.driverDetails.vehicle_no;

    this.spotVehicleData.vehicle_type = this.driverDetails.vehicle_type._id;
    // this.spotVehicleData.vehicle_type = this.selectedVehicle;
    this.spotVehicleData.carrier_type = this.driverDetails.carrier_type;
    this.spotVehicleData.selectedCarrier = this.driverDetails.carrier_unit._id;
    this.spotVehicleData.capacity = this.driverDetails.capacity.toString();
    if (this.driverDetails.rc_laden)
      this.spotVehicleData.rc_laden = this.driverDetails.rc_laden;
    // if (this.driverDetails.desired_weight)
    //   this.spotVehicleData.desired_weight = this.driverDetails.desired_weight;
    if (this.driverDetails.vehicle_weight)
      this.spotVehicleData.vehicle_weight = this.driverDetails.vehicle_weight;
    if (this.driverDetails.driver_image) this.spotVehicleData.driver_image = this.driverDetails.driver_image;
    if (this.customer_name) this.spotVehicleData['customer_name'] = this.parentData.customer.map(c => c.name).join(', ');
    if (this.comments) this.spotVehicleData['comments'] = this.comments;
    if (this.driverDetails.insurance.no) {
      this.spotVehicleData['insurance'] = this.driverDetails.insurance;
    }
    this.spotVehicleData.materials = this.driverDetails.materials;
    this.spotVehicleData.allocation_id = this.parentData._id;
    const valid = this.validate(this.spotVehicleData);
    let url = '';
    url = 'carrier/add_driver';
    if (this.selectedGPSProvider) this.spotVehicleData.gps_provider = this.selectedGPSProvider;
    else {
      delete this.spotVehicleData.gps_provider;
      delete this.spotVehicleData.gps_id;
    }
    if (this.load_id) this.spotVehicleData.load = this.load_id;

    if (valid) {
      this.showLoader = true;
      this.http.post(url, this.spotVehicleData,4).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.showLoader = false;
            // this.isDeleteDriver = false;
            this.messageDeleteStatus = '';
            this.snackbar.openSnackBar(
              this.translate.instant('Vehicle Added Successfully')
            );
            this.dialog.close(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          // if(err.error.message.indexOf('already linked, Delete it') !== -1) {
          // this.isDeleteDriver = true;
          // }
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  // populate assets when provider is selected
  selectGPSProvider(provider) {
    this.selectedGPSProvider = provider;
  }

  selectAsset(asset) {
    this.selectedAsset = asset.reg_number;
    if (asset.asset_id) this.spotVehicleData.gps_id = asset.asset_id;
  }

  applyFilter(value: string) {
    if (value) {
      this.assets = this.assets.filter((option) =>
        option.reg_number.includes(value)
      );
    } else {
      // this.spotVehicleData.gps_id = '';
      this.assets = this.assetsArray;
    }
  }

  selectVehicle(vehicle) {
    // this.postShipmentData.vehicleType = vehicle._id;
    this.vehicleType.id = vehicle._id;
    this.vehicleType.name = vehicle.name;
  }

  openVerifyModal(url) {
    window.open(url, '_blank');
  }
  addCapacity(value) {
    let data = this.capacityData;
    this.capacityData.capacity =
      this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight;
  }
  closeDialog() {
    this.dialog.close();
  }
  getShippers() {
    this.showLoader = true;
    this.http.post('v1/shippers/registered_for', { shipper: this.parentData.shipper._id }).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.registerForArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.registerForArr.push(temp);
          });
        }
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
  }
  getDedicatedShippers() {
    this.showLoader = true;
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.dedicatedShippersArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.name;
            this.dedicatedShippersArr.push(temp);
          });
        }
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
  }
  getCarriers() {
    this.carrierList = [];
    this.http.get('carriers/get').subscribe((response: any) => {
      if (response.data.length) {
        const carriers: any = response.data;
        carriers.forEach((element) => {
          if (element.verified) {
            const temp: any = {};
            temp._id = element._id;
            temp.parent_name = element.parent_name
              ? element.parent_name
              : 'N/A';
            temp.shortName = element.name ? element.name : 'N/A';
            if (element.erp_reference && element.erp_reference.length) {
              const vendor = element.erp_reference[0];
              if (vendor.reference_id) {
                temp.vendor_code = vendor.reference_id;
              }
            }
            temp.name = `${temp.parent_name} - ${temp.shortName}`;
            this.carrierList.push(temp);
          }
        });
      }
    });
    console.log('>>>>>>>>>>>>>>>>>>>>',this.carrierList);
  }
  sub(value) {
    let data = this.capacityData;
    this.capacityData.capacity =
      this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight;
    this.capacityData.desired_weight =
      this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight;
    if (this.materialList.length) {
      this.materialList[0].load = this.capacityData.capacity;
    }
  }
  validateVehicleNo(selectedVehicleNo) {
    if (
      environment.country == 'IN' &&
      !this.valid.isVehicle(selectedVehicleNo)
    ) {
      this.snackbar.openSnackBar(
        this.translate.instant('Enter valid vehicle number'),
        '',
        'err'
      );
      return false;
    } else if (
      (environment.country == 'SA' || environment.country == 'BR') &&
      !this.valid.isKsaVehicle(selectedVehicleNo)
    ) {
      this.snackbar.openSnackBar(
        this.translate.instant('Enter valid vehicle number'),
        '',
        'err'
      );
      return false;
    }
    return true;
  }
  getZones() {
    const country = JSON.parse(localStorage.getItem('country'));
    const payload = {
      country,
    };
    this.http.get('v1/admin/stateDetails', payload).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (data.data) {
            this.states = data.data;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
 

  searchVehicleDetails() {
    // if (this.searchVehicleNo) {
    //   filter.vehicle_no = this.searchVehicleNo;
    //   filter.ignore_delete = true;
    // }
    this.vehicleRegNumbers = this.selectedVehicleNo;
    const valid = this.validateVehicleNo(this.selected);
    if (valid) {


      const payload = {
        is_free: false,
        is_deleted: true,
        vehicle_no: this.selected,
      }

      this.http.get('driver/get_all_attached', payload).subscribe(
        (data: any) => {
          this.clearData();
          this.assignArr = [];
          this.assignArr.length = 0;
          if (data.data.drivers.length > 0) {
            const result = data.data.drivers[0];
            this.spotVehicleData.vehicle_number = result.vehicle_number;
            this.spotVehicleData.name = result.name;
            this.spotVehicleData.comments = result.comments;
            this.spotVehicleData.mobile = result.mobile;
            this.spotVehicleData.vehicle_number = result.vehicle_no;
            this.spotVehicleData.driver_licence_no = result.licence.no;
            this.carrier_type = result.carrier_type;
            this.capacityData.vehicle_qty = result.vehicle_weight;
            if (result.driver_image) this.driverImage = result.driver_image.name;
            this.capacityData.rc_Laden_weight = result.rc_laden;
            this.capacityData.desired_weight = result.desired_weight;
            this.capacityData.capacity = result.capacity;
            this.selectedVehicle = result.vehicle_type._id;
            this.expiryDate = result.licence.expiry_date;
            this.setExpiryDate(this.expiryDate, 'change', 'licence_expiry');
            this.selectedRegisterForName = result.carrier_unit.parent_name;
            this.spotVehicleData.selectedCarrier = result.carrier_unit._id;
            // this.registered_for = result.registered_for;
            this.spotVehicleData.gps_provider = this.selectedGPSProvider;
            this.spotVehicleData.materials = result.material;
            this.spotVehicleData.preferred_location = result.preferred_location;
            this.spotVehicleData.preferred_zone = result.preferred_zone;
            this.customer_name = result.customer_name;
            this.insurance.no = result.insurance.no;
            this.insurance.expiry = result.insurance.expiry;
            this.spotVehicleData.engine_number = result.engine_number;
            this.spotVehicleData.chassis_number = result.chassis_number;
            this.selectedGPSProvider = result.gps ? result.gps.provider : '';
            // if(this.dedicatedShippersArr.length>0){
            //   let dedicated =  this.dedicatedShippersArr.filter(x=>x._id== result.dedicated_to) ;
            //   this.dedicatedName = dedicated?dedicated[0].name:'';
            // }
            // if(this.shippersArr.length>0){
            //   let dedicated =  this.shippersArr.filter(x=>x._id== result.registered_for) ;
            //   this.shipperName = dedicated?dedicated[0].name:'';
            // }

          } else {
            this.snackbar.openSnackBar('No Data Found', '', 'err');
          }

        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }
  paritalSearchVehicleDetails() {
    const payload: any = {
      vehicle_no: this.parital_vehicle_number,
    };
    this.http.get('driver/get_partial_driver', payload).subscribe(
      (data: any) => {
        this.clearData();
        let result = data.data;
        if (result) {
          this.parital_vehicle_number = result.vehicle_no;
          this.spotVehicleData.name = result.name;
          this.spotVehicleData.mobile = result.mobile;
          this.spotVehicleData.vehicle_number = result.vehicle_no;
          this.spotVehicleData.comments = result.comments;
          this.spotVehicleData.driver_licence_no = result.licence.no;
          if (result.driver_image) this.driverImage = result.driver_image.name;
          this.carrier_type = result.carrier_type;
          this.capacityData.vehicle_qty = result.vehicle_weight;
          this.capacityData.rc_Laden_weight = result.rc_laden;
          this.capacityData.desired_weight = result.desired_weight;
          this.capacityData.capacity = result.capacity;
          this.selectedVehicle = result.vehicle_type._id;
          this.expiryDate = result.licence.expiry_date;
          this.setExpiryDate(this.expiryDate, 'change', 'licence_expiry');
          this.selectedRegisterForName = result.carrier_unit
            ? result.carrier_unit.parent_name
            : '';
          this.spotVehicleData.selectedCarrier = result.carrier_unit ? result.carrier_unit._id : '';
          this.spotVehicleData.dedicated_to = result.dedicated_to;
          // this.registered_for = result.registered_for;
          this.spotVehicleData.chassis_number = result.chassis_number;
          this.insurance.no = result.insurance.no;
          this.insurance.expiry = result.insurance.expiry;
          this.spotVehicleData.engine_number = result.engine_number;
          this.preferred.zone = result.preferred_zone;
          this.customer_name = result.customer_name;
          this.spotVehicleData.materials = result.material;
          this.spotVehicleData.preferred_location = result.preferred_location;
          this.spotVehicleData.preferred_zone = result.preferred_zone;
          this.vehicleType1.id = result.vehicle_type._id;
          this.vehicleType1.name = result.vehicle_type.name;
          // if (this.dedicatedShippersArr.length > 0) {
          //   let dedicated = this.dedicatedShippersArr.filter(x => x._id == result.dedicated_to);
          //   this.dedicatedShipper = dedicated ? dedicated[0].name : '';
          // }
          // if (this.shippersArr.length > 0) {
          //   let dedicated = this.shippersArr.filter(x => x._id == result.registered_for);
          //   this.registeredShipper = dedicated ? dedicated[0].name : '';
          // }
        } else {
          this.snackbar.openSnackBar('No Data Found', '', 'err');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  selectRegisterForList(value) {
    this.selectedRegisterForName = value.name;
    this.spotVehicleData.registered_for = [value._id];
  }
  selectdedicated(value) {
    this.enbleMaterial = false;
    // this.enbleregisterfor = false;
    this.dedicatedName = value.name;
    this.spotVehicleData.dedicated_to = value._id;
    this.getMaterials();
    // this.getShippers();
  }
  // selectShipper(value) {
  //     this.shipperName = value.name;
  //     this.registered_for = value._id;
  //   }

  clearData() {
    this.selectedVehicleNo = [];
    this.vehicle_number = '';
    this.spotVehicleData.vehicle_number = '';
    this.spotVehicleData.name = '';
    this.spotVehicleData.mobile = '';
    this.spotVehicleData.vehicle_number = '';
    this.spotVehicleData.comments = '';
    this.spotVehicleData.driver_licence_no = '';
    this.carrier_type = '';
    this.capacityData.vehicle_qty = 0;
    this.capacityData.rc_Laden_weight = 0;
    this.capacityData.desired_weight = 0;
    this.capacityData.capacity = 0;
    this.selectedVehicle = '';
    this.expiryDate = '';
    this.spotVehicleData.selectedCarrier = '';
    this.spotVehicleData.dedicated_to = '';
    // this.registered_for = [];
    this.spotVehicleData.gps_provider = '';
    this.selectedRegisterForName = '';
    this.customer_name = '';
    this.comments = '';
    this.spotVehicleData.chassis_number = '';
    this.spotVehicleData.engine_number = '';
    this.insurance.no = '';
    this.insurance.expiry = '';
  }
  selectMaterial(mat, event, i) {
    // if (event.source._selected && this.material.indexOf(mat.name) == -1) {
    //   this.material.push(mat.name);
    // } else if (this.material.indexOf(mat.name) != -1) {
    //   this.material.splice(this.material.indexOf(mat.name), 1);
    // }

    let names = this.materialList.filter(x => x.name == event.source.value);

    if (names.length > 0 && this.materialList[i].name != event.source.value) {
      this.snackbar.openSnackBar(this.translate.instant('Material already selected. Please choose different material'), '', 'err');
      // this.materialList[index].name=''; 
      event.source.deselect();

    }
  }
  // selectShipper(ship, event) {


  //   if (event.source._selected && this.registered_for.indexOf(ship._id) == -1) {
  //     this.registered_for.push(ship._id);
  //   } else if (this.registered_for.indexOf(ship._id) != -1) {
  //     this.registered_for.splice(this.registered_for.indexOf(ship._id), 1);
  //   }

  // }

  addMaterial() {
    if (this.materialList.length < this.materialsArr.length)
      this.materialList.push({ name: '', load: 0 });
  }

  removeMaterial(i) {
    this.materialList.splice(i, 1);
  }
  deleteSpot() {
    let data: any = {
      mobile: this.spotVehicleData.mobile
    };
    if (this.messageDeleteStatus.indexOf('Search by vehicle') !== -1) {
      data = {
        vehicle_no: this.spotVehicleData.vehicle_number
      };
    }
    this.http.post('driver/remove_driver', data).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.messageDeleteStatus = '';
          // this.isDeleteDriver = false;
          this.snackbar.openSnackBar(data.data, '', 'success');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  fetchGps() {
    const payload = {
      REG_number: this.vehicle_number || this.spotVehicleData.vehicle_number,
    }
    this.http.get('vehicle/get', payload,4).subscribe(
      (data: any) => {
        if (data) {
          if (data.gps && data.gps.provider) {
            this.selectedGPSProvider = data.gps.provider;
          }
          else this.snackbar.openSnackBar('No Gps Found', '', 'err');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
  }

  getVehiclesDetails() {
    this.http.get('v1/vehicleRegisterNumber').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.vehicleRegNumbers = data.data;
          this.selectedVehicleNo = data.data;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  getLinNumbers() {
    this .http.get('/v1/get_LIN_numbers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.lin = data.data;
          this.liin = this.lin.map(function(obj){
            return (obj.LIN);
          });
        }
        this.selectedLinNumber = this.liin;
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  getLinCarrierDetails() {

    const selectLin = this.lin.filter(obj => obj.LIN === this.selectedLin).map(obj => obj._id)[0];
    this.load_id = selectLin;
    const payload = {
      LIN: this.selectedLin
    }
    this.http.get('/v1/get_selected_lin_carrier_details', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) { 
          this.linCarrierDetails = data.data;
          this.carrierList = this.linCarrierDetails[0].carriers.map(c => {
            return {
              name: c.parent_name,
              _id: c._id
            }
          });
          // this.preferred.zone = this.linCarrierDetails[0].state.name;
          this.spotVehicleData.preferred_zone = this.linCarrierDetails[0].state.name;
          this.spotVehicleData.preferred_location = this.linCarrierDetails[0].city;
          // this.preferred.location = this.linCarrierDetails[0].city;
          this.customer_name = this.linCarrierDetails[0].customer.name;

        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  search(query: string) {
    this.vehicleRegNumbers = [];
    console.log('query', query)
    let result = this.filterRegNumber(query);
    this.vehicleRegNumbers = result;
    console.log('end array >>>',this.vehicleRegNumbers);
  }
  filterRegNumber(query: string): string[] {
    let result: string[] = [];
    for (let vehicleNo of this.selectedVehicleNo) {
      if (vehicleNo.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        result.push(vehicleNo);
      }
    }
    return result
  }
  applyVehicleFilter(filterValue: string, type: string) {

    if (type == 'vehicleno') {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.search(filterValue);
      }
    }
  }

  applyLinFilter(filterValue: string, type: string) {
    if (type == 'linNo') {
      this.searchLinNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.searchLin(filterValue);
      }
    }
  }

  searchLin(query: string) {
    this.selectedLinNumber = [];
    let result = this.filterLinNumber(query);
    this.selectedLinNumber = result;
  }

  filterLinNumber(query: string): string[] {
    let result: string[] = [];
    this.selectedLinNumber = this.liin;
    for (let lin of this.selectedLinNumber) {
      if (lin.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        result.push(lin);
      }
    }
    return result;
  }
  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.allVehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  getDriverDetails() {
    const element = this.parentData;
    console.log("🚀 ~ file: assign-load.component.ts:979 ~ AssignLoadComponent ~ getDriverDetails ~ element:", element);
    
    if (this.vehicleNo.length == 10 || this.mobileNo.length == 10) {
    const payload = {
      ...(this.vehicleNo && { vehicle_no: this.vehicleNo }),
      ...(this.mobileNo && { mobile: this.mobileNo }),
    };
    this.http.post('/v1/loads/getDriverDetails', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const result = data.data;
          this.driverDetails = result;
          this.spotVehicleData.dedicated_to = this.parentData.shipper._id;
          this.getShippers();
          this.details = [{
            label: 'Driver Name',
            value: result.name,
          }, {
            label: 'Vehicle Type',
            value: result.vehicle_type.name,
          }, {
            label: 'License No.',
            value: result.licence && result.licence.no,
          }, {
            label: 'Owner Name',
            value: result.owner && result.owner.name || '--',
          }, {
            label: 'Owner Mobile',
            value: result.owner && result.owner.mobile || '--',
          }, {
            label: 'License Expiry Date',
            value: result.licence && result.licence.expiry_date && this.timeService.toShortDate(result.licence.expiry_date) || 'N/A',
          }, {
            label: 'Carrier Type',
            value: result.carrier_type|| 'N/A',
          }, {
            label: 'Carrier',
            value: result.carrier && result.carrier.parent_name || 'N/A',
          }, {
            label: 'Preferred Zone',
            value: result.preferred_zone || 'N/A',
          },{
            label: 'Vehicle RC Weight (MT)',
            value: result.vehicle_weight || 'N/A',
          },
          {
            label: 'RC Tare Weight (MT)',
            value: result.rc_laden || 'N/A',
          },
          {
            label: 'Preferred Location',
            value: result.preferred_location || 'N/A',
          },
          {
            label: 'Materials',
            value: result.materials && result.materials.map(m => m.name).join(', ') || 'N/A',
          },
          {
            label: 'Total Load',
            value: element.accepted || 'N/A',
          },
          {
            label: 'Load QTY (MT)',
            value: result.capacity || 'N/A',
          },
          {
            label: 'Customer Name',
            value: element.customer.map(c => c.name).join(', ') || 'N/A',
          },
          {
            label: 'Insurance Number',
            value: result.insurance && result.insurance.no,
          },
          {
            label: 'Insurance Expiry Date',
            value: result.insurance && result.insurance.expiry && this.timeService.toShortDate(result.insurance.expiry) || 'N/A',
          },
          {
            label: 'Engine No.',
            value: result.engine_number || 'N/A',
          },
          {
            label: 'Chassis No.',
            value: result.chassis_number || 'N/A',
          },
          {
            label: 'GPS Provider Name',
            value: result.vehicle && result.vehicle.gps &&  result.vehicle.gps.provider || 'N/A',
          },
        ]
        }
      },
      (err: any) => {
        this.driverDetails = [];
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }
}

ngOnDestroy() {
  this.carrierId.unsubscribe();
}
}
